import React, { FC } from 'react';
import { LocalizedLink } from 'shared/ui/localized-link';

interface BrowserItemProps {
    url: string;
    browser: string;
}

export const BrowserItem: FC<BrowserItemProps> = ({ browser, url }) => (
    <li>
        <LocalizedLink
            href={url}
            localizationKey={`UnsupportedBrowser.${browser}`}
            target="_blank"
        />
    </li>
);
